import wzm from './map/wzm.js'
import ls from './map/ls.js'
import sxm from './map/sxm.js'
import qym from './map/qym.js'
import hy from './map/hy.js'


const toConcat = (allarr) => {
	let arr = []
	for(let item of allarr) {
		if(item.length) {
			arr = arr.concat(item)
		}
	}
	return arr
}
export default toConcat([wzm, ls, sxm, qym, hy])


// WEBPACK FOOTER //
// ./src/router/maps.js